
(function($) {
	'use strict';

	// Google Map Function
	$.fn.googleMap = function(options) {
		var el = $(this);

		var settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		var markers = [];
		var bounds = new google.maps.LatLngBounds();
		var directionsDisplayOptions = {
			suppressMarkers: true
		};
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer;
		directionsDisplay.setOptions( directionsDisplayOptions );

		// var offsetHeight = $('nav.navbar').position();
		var offsetHeight = $('nav.navbar').height() * 2;

		var map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			var infoButtonString = "";
			var infoImageUrl = "";
			var markerInfowindow = false;
			var icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					fillColor: '#7b7480',
					// anchor: new google.maps.Point(-200, -200),
					scaledSize: new google.maps.Size(36, 36),
					// strokeWeight: 0,
					scale: 0.5,
					// rotation: 0
				};
			}

			if (attr.info_text || attr.info_title) {
				var contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			var marker = add_marker(icon,locLatLng,markerInfowindow);

			markers.push(marker);

			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);

			if (attr.routes) {
				if (Object.keys(attr.routes).length > 1) {

					var routeLocLatLng = new google.maps.LatLng(attr.routes[0].lat, attr.routes[0].lng);
					markers.push(add_marker(icon,routeLocLatLng,markerInfowindow));

					calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);

					let location_pills = $('#location-pills-tab .location-tab-item-action');
					for ( let i=0; i < location_pills.length; i++) {
						if ( !location_pills[i].hasAttribute('hasListener') ) {
							location_pills[i].setAttribute('hasListener', 'true');
							location_pills[i].addEventListener('click', function (e) {
								setTimeout(() => {eventFire(document.querySelector('.show .routes-tab .routes-tab-item-action.active'), 'click')}, 500);
							});
						}
					}

					let location_btn = $('.routes-tab .routes-tab-item-action');
					for ( let i=0; i < location_btn.length; i++) {
						if ( !location_btn[i].hasAttribute('hasListener') ) {
							location_btn[i].setAttribute('hasListener', 'true');
							location_btn[i].addEventListener('click', function (e) {
								var elId = $(this).attr('id');
								$.each(attr.routes, function (k, routeAttr) {

									if (elId === 'pills-' + routeAttr.title.toLowerCase() + '-tab') {
										clearMarkers();
										var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);

										markers.push(add_marker(icon, locLatLng, markerInfowindow));
										markers.push(add_marker(icon, routeLocLatLng, markerInfowindow));

										calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
									}
								});
							});
						}
					}
				}
			}
		});

		function add_marker(icon,marker_position,markerInfowindow) {
			return new google.maps.Marker({
				position: marker_position,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});
		}

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}
		else if (Object.keys(settings.locations).length === 1) {
			map.setZoom(settings.zoom);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
			directionsService.route({
				origin: start,
				destination: end,
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
					directionsDisplay.setMap(map);
				} else {
					window.alert('Directions request failed due to ' + status);
				}
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers() {
			setMapOnAll(null);
		}

		// Sets the map on all markers in the array.
		function setMapOnAll(map) {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(map);
			}
		}
	};

	let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	if (isSafari && navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
		let element = document.querySelector('body');
		element.classList.add('is-safari-mobile');
	}


})(jQuery);


/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		document.getElementById( 'menu-input' ).addEventListener( 'click', ( el ) => {
			if ( el.target.checked ) {
				document.body.classList.add('is-menu-open')
				document.getElementById('wrapper-navbar').classList.add('vh-100')
			}
			else {
				document.body.classList.remove('is-menu-open')
				document.getElementById('wrapper-navbar').classList.remove('vh-100')
			}
		});
		var $map = $('.map');
		if ($map.length > 0) {
			var elMap = $map;
			elMap.googleMap(elMap.data('json'));
		}

		window.onscroll = function(){
			let top = window.pageYOffset || document.documentElement.scrollTop;
			let threshold = document.getElementById('main-nav') !== null ? document.getElementById('main-nav').offsetHeight : 100;
			if (top > threshold ) {
				document.body.classList.add( 'scrolled' );
			} else {
				document.body.classList.remove( 'scrolled' );
			}
		};

			let isAjax = null;
			$('.js-load-more-posts').on('click', ev => {
				ev.preventDefault();
				const $this = $(ev.currentTarget);
				$this.addClass('disabled');
				const originalLabel = $this.text();
				const page = parseInt( $this.get(0).dataset.page );
				$this.text( $this.data('loading'));
				const $target = $($this.attr('data-target'));

				if (isAjax !== null)
					return;
				isAjax = $.ajax( {
					url: THEME_OBJ.ajaxURL,
					type: 'post',
					data: {
						action: $this.get(0).dataset.action,
						nonce: $this.get(0).dataset.nonce,
						offset: $this.get(0).dataset.offset || 0,
						post_id: $this.get(0).dataset.postId || 0,
						posts_per_page: $this.get(0).dataset.perPage || 4,
						page: $this.get(0).dataset.page || 2,
						category: 'pdf',
						lang: 'en',
					},
					beforeSend : function() {
						if(isAjax != null) {
							isAjax.abort();
						}
					},
					success( data ) {
						if ( data ) {
							const d = JSON.parse(data);
							$target.append( d.html );
							if ( true === d.is_last ) {
								$this.addClass('d-none');
							} else {
								$this.get(0).setAttribute('data-offset', d.new_offset); // ???
								$this.get(0).setAttribute('data-page', page + 1 );
							}
						}

					},
					complete() {
						$this.removeClass('disabled');
						$this.text( originalLabel );

						setTimeout(function () {
							isAjax = null;
						}, 500);
					}
				} );
			}).on('mousedown', ev => {
				ev.preventDefault();
			});
	}
};


domLoaded(() => {
	App.init();
});


